<template>
  <router-link class="cta-pill" :to="{name: 'Live'}">Join Live Now</router-link>
</template>

<style src="./pill.css"></style>
